import React, { useMemo } from "react";
import { guides as guidesData } from "../data/guides";

const LatestGuides = () => {

  // Giữ logic lấy 3 bài mới nhất (như trước)
  const guides = useMemo(() => {
    return guidesData.slice(0, 3).map((g) => ({
      ...g,
      // Giả lập lại field cũ để không phải đổi giao diện
      tiktok_embed: `https://www.tiktok.com/video/${g.videoId}`,
    }));
  }, []);

  // Giữ nguyên hàm cũ để không đổi JSX
  const getTikTokVideoId = (url) => {
    const match = url.match(/video\/(\d+)/);
    return match ? match[1] : "";
  };

  return (
    <section className="py-12 bg-white">
      <h2 className="text-3xl font-bold text-center mb-8">
        Cẩm nang mới nhất
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
        {guides.map((guide) => (
          <div
            key={guide.id}
            className="bg-white border border-gray-200 shadow-md rounded-lg p-4 overflow-hidden"
          >
            {guide.tiktok_embed && (
              <div
                className="relative w-full overflow-hidden rounded"
                style={{ paddingBottom: "177.78%" }}
              >
                <iframe
                  src={`https://www.tiktok.com/embed/v2/${getTikTokVideoId(
                    guide.tiktok_embed
                  )}`}
                  className="absolute top-0 left-0 w-full"
                  height="800"
                  frameBorder="0"
                  allowFullScreen
                  title="TikTok video"
                ></iframe>
              </div>
            )}
            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2 text-center">
              {guide.title}
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LatestGuides;